/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCornerRightDown = createReactComponent("outline", "corner-right-down", "IconCornerRightDown", [["path", { "d": "M6 6h6a3 3 0 0 1 3 3v10l-4 -4m8 0l-4 4", "key": "svg-0" }]]);

export { IconCornerRightDown as default };
//# sourceMappingURL=IconCornerRightDown.mjs.map
